import React from "react";
import { Crown } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function PaywallTrialBanner({ user, ios, onStartTrial }) {
  const onTrial = user?.plan === "trial";
  const onPro = user?.plan === "pro";

  if (onPro) {
    return (
      <div className="bg-forest text-white rounded-2xl p-4 text-center font-jakarta space-y-3">
        <div className="font-semibold text-base flex items-center justify-center gap-2">
          <Crown size={18} weight="fill" /> You're Pro until{" "}
          <b>
            {user.pro_until
              ? new Date(user.pro_until).toLocaleDateString()
              : "—"}
          </b>
        </div>
        {!ios && (
          <button
            type="button"
            data-testid="paywall-manage-subscription"
            onClick={async () => {
              try {
                const r = await api.post("/payments/portal", {
                  return_url: window.location.origin + "/",
                });
                window.location.href = r.data.url;
              } catch (e) {
                toast.error(
                  e?.response?.data?.detail || "Couldn't open subscription portal"
                );
              }
            }}
            className="w-full bg-white text-forest font-jakarta font-bold text-sm py-2.5 rounded-full hover:bg-bone transition-colors"
          >
            Manage subscription
          </button>
        )}
        {ios && (
          <p className="text-xs font-jakarta opacity-90">
            Manage in iOS Settings → Apple ID → Subscriptions
          </p>
        )}
      </div>
    );
  }

  if (onTrial) {
    return (
      <div className="bg-orange-soft border border-orange/20 rounded-2xl p-4 text-center font-jakarta text-navy text-sm font-semibold flex items-center justify-center gap-2">
        <Crown size={18} weight="fill" color="#E55B2C" /> Trial active until{" "}
        <b>
          {user.trial_ends_at
            ? new Date(user.trial_ends_at).toLocaleDateString()
            : "—"}
        </b>
      </div>
    );
  }

  // T49.T (Build 81) — Apple 3.1.2(c) rejection fix.
  // App Store products do NOT have a real intro free trial offer
  // configured in ASC. Until that changes, every "free trial" CTA
  // must be absent from the UI AND from the JS bundle. We return
  // null and intentionally do NOT keep legacy JSX even in dead-code
  // form — Terser is not guaranteed to drop string literals from
  // unreachable branches. Restore the legacy CTA from git history
  // once a real ASC trial offer is approved.
  void onStartTrial; // keep eslint happy until the CTA is restored
  return null;
}
